import React from 'react';

const Profile = () => (
  <div>
    <h1> Profile </h1>
  </div>
);
export default Profile;
